import { Link } from 'react-router-dom';
import { hotArticles } from '@/mocks/siteData';

export default function HotArticlesSection() {
  const topArticles = hotArticles.slice(0, 4);

  return (
    <section className="py-14 md:py-20 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
              热门爆料
            </h2>
            <p className="text-foreground-500 text-sm md:text-base mt-2">全网最热吃瓜内容，实时更新</p>
          </div>
          <Link
            to="/category/star-gossip"
            className="hidden sm:flex items-center gap-1 text-foreground-500 hover:text-foreground-800 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {topArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group relative overflow-hidden rounded-2xl bg-background-100 cursor-pointer"
            >
              <div className="relative h-52 md:h-56 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/20 to-transparent"></div>
                {article.badge && (
                  <span className="absolute top-3 right-3 px-2.5 py-1 rounded-full text-[11px] font-semibold bg-primary-500 text-background-50">
                    {article.badge}
                  </span>
                )}
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <h3 className="text-background-50 font-heading font-bold text-sm md:text-base leading-snug line-clamp-2 mb-1.5 group-hover:text-accent-300 transition-colors">
                  {article.title}
                </h3>
                <p className="text-background-50/60 text-xs line-clamp-1">{article.excerpt}</p>
                <div className="flex items-center gap-3 mt-2.5 text-background-50/50 text-[11px]">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {article.views > 10000 ? `${(article.views / 10000).toFixed(1)}万` : article.views}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-chat-1-line"></i>
                    {article.comments}
                  </span>
                  <span>{article.date}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-6 flex sm:hidden justify-center">
          <Link
            to="/category/star-gossip"
            className="flex items-center gap-1 text-foreground-500 hover:text-foreground-800 text-sm font-medium transition-colors cursor-pointer"
          >
            查看全部爆料 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}